export default __webpack_public_path__ + "static/media/14.b6a2620a.mp3";